module.exports = __webpack_public_path__ + "static/media/banner-2.49ecfd26.jpg";